import JobRole from "../JobRole/JobRole";
import blueSvg from "../../images/svg/Blue_paint.svg";
import greenSvg from "../../images/svg/green_paint.svg";
import pinkSvg from "../../images/svg/pink_paint.svg";
import blueButton from "../../images/png/blue-button.png";
import pinkButton from "../../images/png/pinkbutton.png";
import linesSvg from "../../images/svg/lines.svg";
import twoLines from "../../images/svg/two-lines.svg";
import { useEffect, useState } from "react";
import SlideOver from "../slideover/slideover";
import { Myrole } from "../../pages/myrole";
import Header from "../../templates/Header/Header";
import leftDotLineSmall from '../../images/svg/left_dotline_small.svg'
import { userDataState} from "../../atoms/dashboard";
import { useRecoilValue ,useRecoilState } from "recoil";
import { Link } from "react-router-dom";
import JourneyMap from "../../pages/JourneyMap";
import PopOver from "../PopOver/PopOver";
import { explrRols } from "../../selectors/explore-roles";
import {redirect } from "react-router-dom";
import {otherDiv} from "../../atoms/dashboard";
import { frmPage } from "../../atoms/dashboard";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { MycarUrl,Careerlat } from "../../selectors/baseurl";
const ExploreOpportunities = ({ isGridRow, data,isDetailsRequired }) => {

  const usrData = useRecoilValue(userDataState);
  const [width, setWidth] = useState(window.innerWidth);
  const [slideData, setSlideData] = useState([]);
  const [, setotherDiv] = useRecoilState(otherDiv);
  const [,setFrmpg] = useRecoilState(frmPage);
  setFrmpg('explore-roles');
  const [showJourneyMap, setShowJourneyMap] =useState(false);
  const explrRolsData=useRecoilValue(explrRols);
 if (usrData?.isLogged == false) window.location.href = MycarUrl;
 //data=explrRolsData;
  console.log(explrRolsData);
  const driverObj = driver({
    showProgress: true,
    steps: [
      { element: '.job-role-main', popover: { title: 'Top 4 suggested move', description: '<p> This feature provides the Top 4 suggested jobs at RRD (Within and Other Division) based on your Skills and Experience By clicking on details in the each card, the system will display the respective Job`s Role Info and Skill Sets</p>' } },
      { element: '.my-div', popover: { title: 'MyDivision', description: '<p>This feature provides the holistic view of available jobs at RRD in your Division </p>' } },
      { element: '.othr-div', popover: { title: 'Other Division', description: '<p>This feature provides the holistic view of available jobs at RRD other than your Division</p>' } },
      { element: '.sugstd-moves', popover: { title: 'Suggested Move Journey', description: '<p>This feature provides the Top 4 suggested jobs at RRD (Within and Other Division) based on your Skills and Experience along with its Career Progression at RRD </p>' } },
     ]
  });
  const help_coach = () => {
    driverObj.drive();
  };
  function openSlide(getId) {
    console.log(getId);
    //const dts1 = data.filter((val) => val.id == getId);
   console.log('data[getId]',explrRolsData[getId]);
    const title = explrRolsData[getId].level+"-"+explrRolsData[getId].jobPosition;
    setSlideData(
       <SlideOver isCareerLatticePage={true} setSlideData={setSlideData} data={<Myrole datas={explrRolsData[getId]} from={"lattice"}  />} customCls={"lattice"} head={title} />
    );
    document?.querySelector(".slideover")?.classList?.remove("hidden");
  }

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const displayJourneyMap = () => {
    setShowJourneyMap(true);
  }
 const othDiv = ()=> {
  setotherDiv(true);
  window.location.href =Careerlat;
 }
 const myDiv = ()=> {
  setotherDiv(false);
  window.location.href =Careerlat;
 }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const avatarImg = "https://myconnect-pages.rrd.com/IconnectReader/iConnectUploadData/EMPPhotoNew/" + usrData?.empID + ".JPG";

  const isMobile = width <= 768;
  console.log('showJourneyMap', showJourneyMap);

  return (
    <>
      {!showJourneyMap ? <div className="mx-auto w-full">
        <div className="main-section">
          {isGridRow && <Header onBtnClick={help_coach}/>}
          <main>
            <div className={`bg-white ${isGridRow ? 'explore-opportunities-main' : ""} mx-auto h-full w-full`}>
              {isGridRow && (
                <div>
                  <div className="flex items-center justify-between pt-6 pb-6 px-7 explore-steps">
                    {/* heading */}
                    {/* <h2 className="ml-0 text-[16px] text-[#033d9b] tracking-[2px] font-extrabold">EXPLORE ROLES</h2> */}
                    <div className="breadcrumb">
              {/* <span className="text-center inline-block ml-[16px] font-bold opacity-50">
                RRD
              </span> */}
              <h2 className="ml-0 text-[16px] text-[#033d9b] tracking-[2px] font-extrabold uppercase">
              <Link to='/dashboard'>Dashboard</Link> /  Compactable Streams/Roles
              </h2>
            </div>
                    <div className="flex items-center gap-3">
                      <div className="flex items-center gap-2">
                        <span className="inline-block h-3 w-3 bg-[#478efd] rounded-sm"></span>
                        <h3 className="text-[#312424]">CURRENT DIVISION</h3>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="inline-block h-3 w-3 bg-[#c9407f] rounded-sm"></span>
                        <h3 className="text-[#312424]">OTHER DIVISION</h3>
                      </div>
                    </div>
                  </div>

                  {/* steps parent */}
                  <div>
                    {/* outer parent */}
                    <div className=" border-3 border-purple-700">
                      <div className="grid grid-cols-3 w-[70%] my-0 mx-auto place-items-center steps-main">
                    <Link onClick={myDiv}>
                    <div className="relative h-full my-0 mx-auto grid place-items-center my-div">
                          <img className="w-32" src={blueSvg} alt="blue SVG" />
                          <div className="w-[65%] absolute top-[35%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
                            <img
                              className="cursor-pointer"
                              src={blueButton}
                              alt="blue button"
                            />
                          </div>
                          <div className="text-[#033d9b]">
                            <h1 className="text-center font-bold text-sm">EXPLORE IN</h1>
                            <h2 className="text-center font-bold text-base">MY DIVISION</h2>
                          </div>
                        </div>
                        </Link>
                        <div className="relative h-full  my-0 mx-auto grid place-items-center">
                          <img className="h-44" src={greenSvg} alt="green SVG" />
                          <div className="absolute top-[50%] left-[55%] translate-x-[-50%] translate-y-[-50%] h-[90px] w-[92px] bg-white border-[3px] border-[#418aff] rounded-full overflow-hidden">
                            <img src={avatarImg} alt="avatar" className="p-[3px]" />

                            {/* <button className="text-center bg-[#356a31] px-[12px] py-1 mt-4 rounded-full text-white font-bold">
                  YOU TODAY
                </button> */}
                          </div>
                          <button className="text-center bg-[#356a31] px-3 py-1 mt-4 ml-4 rounded-full text-white font-semibold absolute top-[70%]">
                          Current Level 
                          </button>
                          <div></div>
                        </div>
                        <Link  onClick={othDiv}>
                        <div className="relative h-full my-0 mx-auto grid place-items-center othr-div">
                          <img className="w-32" src={pinkSvg} alt="pink SVG" />
                          <div className="w-[65%] absolute top-[35%] left-[50%] translate-x-[-50%] translate-y-[-50%] ">
                            <img
                              className="cursor-pointer"
                              src={pinkButton}
                              alt="pink button"
                            />
                          </div>
                          <div className="text-[#d91974]">
                            <h1 className="text-center font-bold text-sm">EXPLORE IN</h1>
                            <h2 className="text-center font-bold text-base text-[#d91974]">OTHER DIVISION</h2>
                          </div>
                          <div></div>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* current position */}
                  <div className="grid place-items-center mt-2">
                  <h2 className="text-black font-bold text-sm ml-[30px]">
                      {/* Production Specialist - MSO (L3) */}
                      {usrData?.jobTitleName + " " + "(" + usrData?.jobLevelName + ")"}
                    </h2>
                    <h4 className="font-semibold opacity-50">
                      {/* Docuemnt - Doc Creative */}
                      {usrData?.streamName}
                    </h4>
                  </div>

                  {/* svg lines */}
                  {data?.length >= 4 && <div className="grid place-items-center w-full svg-lines mt-5">
                    <img
                      className={`svg-lines max-w-[85%] ${isMobile ? "min-w-[50%]" : "min-w-[75%]"
                        }`}
                      src={isMobile ? twoLines : linesSvg}
                      alt="lines svg"
                    />
                  </div>}

                  {data?.length == 1 && <div className="grid place-items-center w-full svg-lines mt-5">
                    <img
                      className={`svg-lines max-w-[85%] ${isMobile ? "min-w-[50%]" : "min-w-[75%]"
                        }`}
                      src={isMobile ? twoLines : leftDotLineSmall}
                      alt="lines svg"
                    />
                  </div>}
                </div>
              )}

              {/* Job Role */}
              <div
                className={`${isGridRow
                  ? "px-20 py-0 rounded-2xl"
                  : "px-15 py-5 mx-5 rounded-2xl"
                  }`}
              >
                <div
                  className={`${isGridRow
                    ? `grid grid-cols-4 gap-4 `
                    : "grid grid-rows-4 gap-8"
                    } job-role-main`}
                >
                  {explrRolsData?.map((val,indx,arr) => { console.log(val)
                    return (
                      <JobRole
                        key={indx}
                        data={val}
                        callback={openSlide}
                        isDetailsRequired={isDetailsRequired}
                        valsid={indx}
                        div={val?.divisionName?.includes(usrData?.divisionName)?'current':'others'}
                        arr={arr}
                        setSlideData={setSlideData}
                      />
                    );
                  })}
                </div>

                {isGridRow && (
                  <div className="pb-12">
                    <div className="bg-gray-50 p-3 mt-5 text-center flex items-center justify-center border-[#f5f5f5] border">
                      <h3 className="font-bold text-xs">
                      These are system suggested Streams/Roles after careful review of your Primary Skills, Proficiency and Overall Experience
                      </h3>
                    </div>

                    <div className="flex items-center justify-center mt-7 sugstd-moves">
                       <Link to='/journey-map'>
                       <PopOver content="Click to Explore More" direction="right">
                        <button onClick={displayJourneyMap} className="bg-[#033d9b] px-16 py-3 rounded-full flex items-center justify-center text-white font-medium text-base">
                        Click to Explore More 
                        </button>
                      </PopOver>
                      </Link> 
                    </div>
                  </div>
                )}
              </div>
              {slideData}
            </div>
          </main>
        </div>
      </div>:<JourneyMap showJourneyMap={showJourneyMap} setShowJourneyMap={setShowJourneyMap}  isGridRow={false} isDetailsRequired={false}/> }
    </>
  );
};

export default ExploreOpportunities;
